import { PageMeta } from '../insights/insights.models';

const GROUPS_LIST_PAGE_META: Record<string, PageMeta> = {
	'^/groups$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-list'
	}
};

const GROUP_EDIT_PAGE_META: Record<string, PageMeta> = {
	'^/groups/\\d+$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-edit'
	}
};

const GROUP_NEW_PAGE_META: Record<string, PageMeta> = {
	'^/groups/new$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-new'
	}
};

const GROUP_COURSES_PAGE_META: Record<string, PageMeta> = {
	'^/groups/.+/courses$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-courses'
	}
};

const GROUP_LEARNING_JOURNEY_PAGE_META: Record<string, PageMeta> = {
	'^/groups/.+/learning-journeys$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-learning-journeys'
	}
};

const GROUP_USER_PAGE_META: Record<string, PageMeta> = {
	'^/groups/.+/users$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-users'
	}
};

const GROUP_MANAGERS_PAGE_META: Record<string, PageMeta> = {
	'^/groups/.+/managers$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-managers'
	}
};

const GROUP_LEADER_BOARD_PAGE_META: Record<string, PageMeta> = {
	'^/groups/.+/leaderboard$': {
		pagegroup: 'groups',
		pagename: 'admin-groups-leaderboard'
	}
};

export default {
	...GROUPS_LIST_PAGE_META,
	...GROUP_EDIT_PAGE_META,
	...GROUP_NEW_PAGE_META,
	...GROUP_COURSES_PAGE_META,
	...GROUP_LEARNING_JOURNEY_PAGE_META,
	...GROUP_USER_PAGE_META,
	...GROUP_MANAGERS_PAGE_META,
	...GROUP_LEADER_BOARD_PAGE_META
};
